
/**
 * 设置初始化SDK
 *
 */
import {getUrlParams} from '../../utils';
import {taskSupplier} from '@baidu/ug-task-supplier';
import '@baidu/ug-task-supplier/dist/h5/index.css';

const params = getUrlParams(location.href);
const {taskInfo = ''} = params || {};

let query = {
    taskInfo: taskInfo, // 取自Url中taskInfo参数
    // 设置UI组件位置
    style: { // 默认设置在右侧
        top: '',
        bottom: '',
        left: '',
        right: '',
        zIndex: '10000'
    }
};
export function initSDK() {
    taskSupplier.init({
        query,
        sdkConfig: {
            // 任务方任务id与加密token的映射，此密钥配置配置在任务平台，一个任务具有一个唯一的key
            secretMap: {
                1311: 'Hwh76OaGDSkDlxlH+A1oagknf16SndUySyebqn01czM='
            }
        }
    });
}
export function executeSDK() {
    // 对于任务id为1284任务开始计时
    taskSupplier.execute({
        command: 'start',
        aid: [1311]
    });
}
